<template>
    <div class="my_treat_page">
        <div class="head">
            <div class="info" style="width: 55%;">
                <div class="text" style="font-size: 16px;">{{uname }}</div>
                <div  class="text">
                    <span>{{usex }}</span>
                    <span> {{uage}}</span>
                    <span>{{uphone}}</span>
                </div>

            </div>
            <div class="info" style="width: 50%;margin-left: 35px;">
                <div class="text" style="text-align: left;">诊所：{{ ClinicName }}</div>
                <div class="text">工号：{{ dispname }}</div>
            </div>
        </div>
        <div class="list">
            <div class="list_top">
                <div :class="{user:true,active:item.status}" v-for="item in family" @click="chooseUser(item)">
                    <div>
                        <div class="item">{{ item.name }}</div>
                        <div class="item">{{item.phone && (item.phone).replace(/(\d{3})\d{4}(\d{4})/, "$1****$2") || ''}}</div>
                    </div>
                </div>
            </div>

            <div style="display: flex;justify-content: center;gap: 15px;" >
                <!-- $router.push({path:'/otherPay',query:{userid,customerid,}}) -->
                <div
                    :class="{list_btn:true,list_btn_disabled:isNoAssignableProject}"
                    @click="openBedPopup()">
                  {{ uroomid ? '床位：'+uroomname : '安排床位' }}
                </div>
                <div class="list_btn" @click="chooseOther()">
                    他人抵扣
                </div>
            </div>

            <van-checkbox-group v-model="result" v-if="list.length > 0" @change="handleProjectSelectChange">
                <div class="list_item"  v-for="item in list" :key="item.projectcode" >
                    <div style="display: flex;justify-content: space-between;">
                        <div class="tream">
                            <van-checkbox  checked-color="#CF8C57" :name="item">
                                <div class="text">{{ item.projectname }}</div>
                            </van-checkbox>
                        </div>
                        <div class="text" style="font-size: 14px;font-weight: 400;">剩<span style="color: #EE0A23;">{{ item.remainnum}}</span>次/共<span style="color: #EE0A23;">{{ item.totalnum}}</span>次</div>
                    </div>
                    <van-cell style="border-bottom: 1px solid #D8D8D8;margin-bottom: 0">
                      <template #title>
                        <span>执行次数：</span>
                      </template>
                      <template #default>
                        <div style="width:80px;margin-left:auto;">
                          <van-field
                              v-model="item.execnumValue"
                              type="digit"
                              input-align="center"
                              class="execute-input"
                              style="padding: 0"
                              :style="item.isallowtimes == 1
                                      ? 'border:1px solid #dcdfe6;border-radius:4px;'
                                      : ''"
                              :readonly="item.isallowtimes != 1"
                              @input="handleExecnumChange(item)"
                          />
                        </div>
                      </template>
                    </van-cell>
                    <van-cell :value="doctor.dispname" v-for="(doctor, index) in item.doctors" :key="item._key + '_' + doctor.username + '_' + index" :border="false" @click="chooseDoctor(item, index)" is-link style="margin-bottom: 0;padding-bottom: 0">
                        <template #title>
                          <div class="doctor-title">
                            <span v-if="doctor.ismain == 1" class="main-tag">主</span>
                            <span>执行医生：</span>
                          </div>
                        </template>
                        <template #value>{{ doctor.dispname }}</template>
                    </van-cell>
<!--                    <div class="action-buttons">-->
<!--&lt;!&ndash;                        <div style="display:flex;align-items: center;">&ndash;&gt;-->
<!--&lt;!&ndash;                            <van-icon name="add-o" />&ndash;&gt;-->
<!--&lt;!&ndash;                            <van-button plain type="primary" size="small" class="l-btn" @click.stop="addDoctor(item)">添加医生</van-button>&ndash;&gt;-->
<!--&lt;!&ndash;                        </div>&ndash;&gt;-->
<!--                        <van-button type="primary" color="#CF8C57" class="r-btn" size="small" @click="openAcupointDialog(item)">配穴分工</van-button>-->
<!--                    </div>-->
                </div>


            </van-checkbox-group>
            <div class="has_no_data" style="margin-top: 40px;" v-else>
                当前无可分诊的理疗项目
            </div>

        </div>

        <div style="position: fixed;left: 0;right: 0;bottom: 20px;margin: 0 35px;">
            <van-button
                color="#CF8C57"
                round
                @click="assignTreat"
                size="large"
                :disabled="isAssigning"
                :loading="isAssigning"
                loading-text="分诊中..."
                class="confirm-btn"
            >{{ isNoAssignableProject ? '去开单' : '确认分诊' }}</van-button>
        </div>


        <van-popup v-model="showPicker" round position="bottom">
            <van-picker
                title="请选择医生"
                show-toolbar
                :columns="doctorList"
                :default-index="doctorList.findIndex(item => item.username == selectDoctor)"
                @cancel="showPicker = false"
                @confirm="onConfirmDoctor"
            ><template #option="item"><span v-if="item.ishelp == 1">(助)</span>{{ item.dispname }}</template>
        </van-picker>
        </van-popup>
        <van-popup v-model="showPicker2" round position="bottom">
            <van-picker
            title="请选择诊室"
            show-toolbar

            :columns="roomList"
            @confirm="onConfirmRoom"
            @cancel="showPicker2 = false"
        ><template #option="item">{{ item.roomname }}</template></van-picker>
        </van-popup>
        <!-- <van-popup v-model="showPay" closeable round position="bottom" :style="{height:'90%'}">
            <OtherPay></OtherPay>
        </van-popup> -->
        <van-dialog v-model="shownum" title="获取验证码" show-cancel-button confirm-button-color="#CF8C57" :before-close="close">
            <div style="padding: 5px;margin-bottom: 20px;">
                <van-field v-model="tel" label-width="50" type="tel" label="手机号" :center="true">
                    <template #left-icon>
                        <img src="@/assets/phone.png" alt="" style="height: 20px;width: 20px;">
                    </template>
                </van-field>
                <van-field
                    v-model="sms"
                    center
                    label-width="50"
                    clearable
                    label="验证码"
                    placeholder="请输入短信验证码"
                    >
                    <template #button>
                        <van-button size="small" color="#CF8C57" type="primary"  @click="sendCode" :disabled="countdown > 0">
                            {{ countdown > 0 ? `${countdown}秒后重新获取` : '获取验证码' }}
                        </van-button>
                    </template>
                    <template #left-icon>
                        <img src="@/assets/code.png" alt="" style="height: 20px;width: 20px;">
                    </template>
                </van-field>
            </div>
        </van-dialog>

        <van-dialog
            v-model:show="showBedPopup"
            :show-confirm-button="false"
            :close-on-click-overlay="false"
            class="bed-dialog">
          <template #title>
            <div class="dialog-title">
              <span>安排床位</span>
            </div>
          </template>
          <div class="bed-popup">
            <div class="patient-info-section" style="display: flex;align-items: center;justify-content: space-between;">
              <div class="patient-header">{{uname}}</div>
              <div class="patient-detail">{{usex}} {{uage}}</div>
            </div>
            <div class="bed-section">
              <div class="bed-list">
                <div
                    v-for="bed in bedList"
                    :key="bed.room_id"
                    class="bed-item"
                    :class="{
                       'bed-occupied': bed.use_count > 0  && (bed.user_id != userid || bed.customer_id != customerid),
                       'bed-available': bed.use_count <= 0 || (bed.use_count > 0 && bed.user_id == userid && bed.customer_id == customerid),
                       'bed-selected': selectedBed?.room_id == bed.room_id
                    }"
                    @click="selectBed(bed)">
                  <div v-if="bed.room_id != -1" style="text-align: center">
                    <div>{{ bed.room_name }}</div>
                  </div>
                  <div v-else class="freeRoom">
                    <span>{{ bed.room_name }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="confirm-section">
              <div class="confirm-btn" @click="confirmAssignBed">确认安排</div>
            </div>
          </div>
        </van-dialog>

        <acupoint-allocation
            :visible.sync="showAcupointDialog"
            :qryType="1"
            :uname="uname"
            :usex="usex"
            :uage="uage"
            :uphone="uphone"
            :userId="Number(currentUserId)"
            :customerId="Number(currentCustomerId)"
            :tCode="currenttCode"
            :qrydate="qryDate"
            :currentAcupointData="currentAcupointData"
            @save="handleAcupointSave"
        />
    </div>
</template>
<script>
import {
  wxtreattriageopr,
  wxtriageprojectqry,
  wxtriagedoctorroomqry,
  curuserqrytreattriage,
  wxtreatuserphonecaptchano,
  wxqryfreeroom,
  wxoprtreat
} from '@/api/medical'
import { mapGetters } from 'vuex'
import { Toast,Dialog } from 'vant';
import OtherPay from '../otherPay/index.vue'
import AcupointAllocation from '../acupointAllocation/index.vue'
const TREAT_WAIT_SCROLL_TO_BOTTOM = 'TREAT_WAIT_SCROLL_TO_BOTTOM'
/**
 * 归一化加项目来源状态，只有执行中/已完成入口传入的 1 会透传给确认分诊接口。
 */
function normalizeTreatStatus(treatstatus) {
  return treatstatus == '1' ? '1' : '0'
}
export default{
    computed: {
            ...mapGetters([
                'username','dispname','clinicid'
            ]),
            isNoAssignableProject() {
              return this.projectLoaded && (!Array.isArray(this.list) || this.list.length == 0)
            }
        },
        components:{
            OtherPay,
            AcupointAllocation
        },
    data(){
        return{
            tel:'',//手机号
            list:[],
            userList:[],
            result:[],
            selectedProjectCodes:[],
            projectLoaded:false,
            isAssigning:false,
            showPicker:false,
            selectDoctor:null,
            showPicker2:false,
            treatitem:{},
            ClinicName:'',
            doctorList:[],
            roomList:[],
            family:[ ],
            radio:'',
            other:{},
            userprojectlist:[],
            len:'',
            shownum:false,
            sms:'',
            phone:'',
            countdown: 0,
            userid:this.$route.query.userid || localStorage.getItem('userida'),
            customerid:this.$route.query.customerid || localStorage.getItem('customerida'),
            usecustomerid:this.$route.query.customerid || localStorage.getItem('customerida'),
            useuserid:this.$route.query.userid || localStorage.getItem('userida'),
            uname:this.$route.query.name || localStorage.getItem('namea'),
            appointmentid: this.$route.query.appointmentid,
            uage:this.$route.query.age|| localStorage.getItem('agea'),
            usex:this.$route.query.sex || localStorage.getItem('sexa'),
            uphone:this.$route.query.phone || localStorage.getItem('phonea'),
            uroomid:this.$route.query.roomid,
            uroomname:this.$route.query.roomname,
            showPay:false,
            intervalId:null,
            historynum:null,
            showAcupointDialog:false,
            currentAcupointData:[],
            currentItemRef: null,
            currentUserId: null,
            currentCustomerId: null,
            currenttCode: null,
            oprtype:this.$route.query.oprtype || '2', // 1:转理疗分诊，2:直接分诊

            showBedPopup:false,
            bedList:[],
            selectedBed:null,
            defaultDate: new Date(),
            date:'',
            qryDate:this.$route.query.qryDate || '',
            treatstatus: normalizeTreatStatus(this.$route.query.treatstatus),
            assignSuccessServiceid:'',
        }
    },
    mounted () {
        this.$store.dispatch('hideOrShowNav', false)

        this.initQryDate()

    },
    beforeRouteEnter(to, from, next) {

        if(from.path == '/otherPay'){
            next(vm =>{
                vm.uname = localStorage.getItem('namea')
                vm.uage = localStorage.getItem('agea')
                vm.usex = localStorage.getItem('sexa')
                vm.uphone = localStorage.getItem('phonea')
                vm.userid = localStorage.getItem('userida')
                vm.customerid = localStorage.getItem('customerida')
                vm.treatstatus = normalizeTreatStatus(to.query.treatstatus)
                // vm.userprojectlist = JSON.parse(localStorage.getItem('userprojectlist'))
                vm.historynum = localStorage.getItem('historynum')
                vm.result = []
                vm.selectedProjectCodes = []

                if(localStorage.getItem('familya') != 'undefined'){
                    vm.family = JSON.parse(localStorage.getItem('familya'))
                    vm.len = vm.family.length

                }else{

                    vm.len = 0
                    vm.family = []
                }

                // to.meta.keepAlive = true
                vm.ClinicName = sessionStorage.ClinicName
                // vm.getuser()

                if(localStorage.getItem('otherdata')){

                    vm.onConfirmOther(JSON.parse(localStorage.getItem('otherdata')|| ''))
                }


            })
        }else{
            next(vm =>{

                // to.meta.keepAlive = false
                vm.$store.dispatch('hideOrShowNav', false)
                vm.uname = localStorage.getItem('namea')
                vm.uage = localStorage.getItem('agea')
                vm.usex = localStorage.getItem('sexa')
                vm.uphone = localStorage.getItem('phonea')
                vm.userid = localStorage.getItem('userida')
                vm.customerid = localStorage.getItem('customerida')
                vm.treatstatus = normalizeTreatStatus(to.query.treatstatus)
                // vm.userprojectlist = JSON.parse(localStorage.getItem('userprojectlist'))
                vm.historynum = localStorage.getItem('historynum')
                vm.result = []
                vm.selectedProjectCodes = []
                vm.getuser()

            })
        }
    },
    beforeRouteLeave(to, from, next) {

        if(to.path == '/triage'){
            to.meta.keepAlive = true

            localStorage.removeItem('userida')
            localStorage.removeItem('customerida')
            localStorage.removeItem('namea')
            localStorage.removeItem('agea')
            localStorage.removeItem('sexa')
            localStorage.removeItem('phonea')
            localStorage.removeItem('familya')
            localStorage.removeItem('otherdata')
            // localStorage.removeItem('userprojectlist')
            localStorage.removeItem('historynum')
        }else if(to.path == '/otherPay'){
            to.meta.keepAlive = true
            localStorage.setItem('familya',JSON.stringify(this.family))
        }
        else if(to.path == '/'){
            from.meta.keepAlive = false
        }
        next()
    },
    created(){
        this.initQryDate()

        localStorage.setItem('userida', this.$route.query.userid);
        localStorage.setItem('customerida', this.$route.query.customerid);
        localStorage.setItem('namea', this.$route.query.name);
        localStorage.setItem('agea', this.$route.query.age);
        localStorage.setItem('sexa', this.$route.query.sex);
        localStorage.setItem('phonea', this.$route.query.phone);




        this.gettriageprojectqry(this.userid,this.customerid)
        this.getdoctorroomList()

        this.ClinicName = sessionStorage.ClinicName
    },
    methods:{
        close(action, done){

            if (action == 'confirm' && !this.sms.trim()) {
                Toast.fail('请输入验证码！')
                done(false)
            } else if(action == 'cancel'){
                this.isAssigning = false
                this.countdown = 0;
                clearInterval(this.intervalId);
                this.intervalId = null

                done(true)

            }
            else {
                this.getTreat('3',this.sms.trim()).then(res=>{
                    if(res.response_head.retinfo.retcode == '0'){
                        done(true)
                    }else{
                        done(false)
                    }
                }).catch(err=>{

                    Toast.fail(err.response_head.retinfo.retmsg)
                    done(true)
                })

            }
        },
        sendCode() {
            // 模拟发送验证码的操作

            let data = {
                username:this.username,
                userid:this.other.userid,
                customerid:this.other.customerid
            }

            wxtreatuserphonecaptchano(data).then(response =>{

                this.countdown = 60;

                // 开始倒计时
                this.intervalId = setInterval(() => {
                    if (this.countdown > 0) {
                    this.countdown -= 1;
                    } else {
                    clearInterval(this.intervalId);
                    }
                }, 1000);


            }).catch(()=>{
                Toast.fail('获取验证码失败！')
            })

            // 设置倒计时为60秒

        },
        chooseOther(){
            this.$store.dispatch('changeIsRefresh', '1')
            this.$router.push({path:'/otherPay',query:{userid:this.$route.query.userid,customerid:this.$route.query.customerid,oprtype:this.oprtype,qryDate:this.qryDate,treatstatus:this.treatstatus}})
        },
        /**
         * 无可分诊项目时跳转快速接诊，固定使用进入分诊页时的患者信息开单。
         */
        goPrescription(){
            const query = {
                userid: this.$route.query.userid || this.userid,
                customerid: this.$route.query.customerid || this.customerid
            }

            if (this.$route.query.prescriptionid != null) {
                query.prescriptionid = this.$route.query.prescriptionid
            }

            if (this.$route.query.appointmentid != null) {
                query.appointmentid = this.$route.query.appointmentid
            }

            this.$router.push({ path: '/prescription', query })
        },
        chooseUser(item){
            this.projectLoaded = false
            this.list = []
            this.result = []
            this.selectedProjectCodes = []
            let userid = this.$route.query.userid
            let customerid = this.$route.query.customerid
            this.tel =item.phone && (item.phone).replace(/(\d{3})\d{4}(\d{4})/, "$1****$2")
            // 用id判断
            this.family.map((val,index) => {
                if(item.userid == val.userid && item.customerid == val.customerid){
                    val.status = !val.status
                }else{
                    val.status = false
                }
                if(val.status ){
                    this.other = item

                    this.useuserid = val.userid
                    this.usecustomerid = val.customerid
                    userid = val.userid
                    customerid = val.customerid
                }
            })
            this.gettriageprojectqry(userid,customerid)
        },
        // 查看可分诊用户
        getuser(){
            let data = {
                username: this.username,
                userid:this.userid,
                customerid:this.customerid,
                oprtype:this.oprtype,
                qrydate:this.qryDate
            }
            curuserqrytreattriage(data).then(response =>{

                this.family = response.response_body.list?.map(item =>{
                    item.status = false
                    return item
                })

                localStorage.setItem('familya',JSON.stringify(this.family))

                if(this.family == undefined){

                    this.len = '0'
                    this.family = []
                }else{

                    this.len = this.family.length
                }


                console.log(response.response_body.otherlist)
                if (response.response_body.otherlist && response.response_body.otherlist.length >0){
                  console.log(response.response_body.otherlist)
                  const otherItem = response.response_body.otherlist.find(
                      familyItem =>
                          familyItem.projectlist &&
                          familyItem.projectlist.some(
                              project => Number(project.curexecnum) > 0
                          )
                  )
                  if (otherItem){
                    if(localStorage.getItem('familya') != 'undefined'){
                      let arr = JSON.parse(localStorage.getItem('familya'))
                      if(arr.filter(val => val.userid == otherItem.userid && val.customerid == otherItem.customerid).length > 0){
                        Toast(`当前【${otherItem.name}】的账号已存在`)
                        return
                      }
                    }

                    console.log("otherdata",JSON.stringify(otherItem))
                    localStorage.setItem('otherdata',JSON.stringify(otherItem))
                    this.onConfirmOther(JSON.parse(localStorage.getItem('otherdata')|| ''))
                  }
                }else {
                  const defaultItem = this.family.find(
                      familyItem =>
                          familyItem.projectlist &&
                          familyItem.projectlist.some(
                              project => project.serviceids
                          )
                  )

                  console.log("--==",defaultItem)
                  if (defaultItem) {
                    this.chooseUser(defaultItem)
                  }
                }

            })
        },
        // 查询医生
        getdoctorroomList(){
            let data = {
                username: this.username,
                clinicid:sessionStorage.ClinicId,
                qrytype : '2',
                qrydate:this.qryDate
            }
            wxtriagedoctorroomqry(data).then(response =>{

                this.doctorList = response.response_body.doctorlist
                this.roomList = response.response_body.roomlist
            })
        },
        onConfirmOther(val){
            // this.result = []
            // this.showPicker3 = false
            this.projectLoaded = false

            if(this.len){
                this.family?.map((val,index) => {
                    val.status = false

                })
            }

            this.list = Array.isArray(val.projectlist) ? val.projectlist : []
            this.other = val
            this.useuserid = val.userid
            this.usecustomerid = val.customerid
            this.tel =val.phone && (val.phone).replace(/(\d{3})\d{4}(\d{4})/, "$1****$2")


            val.status = true

            if(this.family.filter(item => val.userid == item.userid && val.customerid == item.customerid).length == 0){

                this.family.push(val)
            }
            localStorage.setItem('familya',JSON.stringify(this.family))
            // this.family.push(val)
            this.gettriageprojectqry(val.userid,val.customerid)

        },

        // 可分诊项目查询
        gettriageprojectqry(userid,customerid){
            this.projectLoaded = false
            let useuserid = ''
            let usecustomerid = ''
            if(this.userid == userid && this.customerid == customerid){
                 useuserid = ''
                 usecustomerid = ''
            }else{
                useuserid = this.$route.query.userid
                usecustomerid = this.$route.query.customerid
            }

            let data = {
                    username: this.username,
                    projectcode:'',
                    keyword:'',
                    userid,
                    customerid,
                    qrytype:'0',
                    qrypage:1,
                    useuserid,
                    usecustomerid,
                    clinicid:this.clinicid,
                    oprtype:this.oprtype,
                    qrydate:this.qryDate
                }
            Toast.loading({
              message: '加载中...',
              forbidClick: true,
              duration: 0
            })
            wxtriageprojectqry(data).then(response =>{
                const responseBody = response.response_body || {}
                const responseList = Array.isArray(responseBody.list) ? responseBody.list : []
                const currentUser = responseList[0] || {}
                const projectlist = Array.isArray(currentUser.projectlist) ? currentUser.projectlist : []

                if(responseBody.pages == 0){
                    this.userList = []
                    this.list = []
                    this.result = []
                    this.selectedProjectCodes = []
                    this.userprojectlist = []
                    this.uroomid = responseBody.roomid
                    this.uroomname = !responseBody.roomname && this.uroomid == -1 ? '无需床位' : responseBody.roomname
                    this.projectLoaded = true
                    Toast.clear()
                }else{

                    if(userid == this.$route.query.userid && customerid == this.$route.query.customerid){

                        // this.userprojectlist = response.response_body.list[0].projectlist
                        this.historynum = currentUser.historynum
                        // localStorage.setItem('userprojectlist',JSON.stringify(this.userprojectlist))
                        localStorage.setItem('historynum',this.historynum)
                    }
                    this.userList = responseList

                    if (this.oprtype == '1'){
                      this.list = projectlist.filter(item => item.surplusnum > 0 && item.serviceids) || []
                      this.userprojectlist = projectlist.filter(item => item.serviceids)
                    }else{
                      this.list = projectlist.filter(item => item.surplusnum > 0) || []
                      this.userprojectlist = projectlist
                    }
                    this.result = this.list.filter(item => Number(item.curexecnum) > 0) // 默认选中
                    this.selectedProjectCodes = this.result.map(item => item.projectcode)
                    this.list.forEach((item, i) => {
                        if (!Array.isArray(item.doctors)) {
                            this.$set(item, 'doctors', [])
                        }

                        // 初始化执行次数，默认使用接口返回的 curexecnum。
                        this.$set(item, 'execnumValue', item.curexecnum === undefined || item.curexecnum === null ? '' : String(item.curexecnum))
                        item._key = i
                        item.doctors = [
                            {
                                dispname: item.doctorname || this.dispname,
                                username: item.doctor || this.username,
                                ismain: 1
                            }
                        ],
                        item.room = '请选择诊室',
                        item.roomid = ''
                    })
                    this.uroomid = responseBody.roomid
                    this.uroomname = !responseBody.roomname && this.uroomid == -1 ? '无需床位' : responseBody.roomname
                    this.projectLoaded = true
                    Toast.clear()
                    if (this.list.length > 0 && !this.uroomid) {
                      this.openBedPopup()
                    }
                }

            }).catch(() => {
                Toast.clear()
                this.projectLoaded = false
                Toast.fail('加载失败')
            })
        },
        // 勾选项目后默认执行 1 次；取消勾选后将执行次数归 0，并恢复已占用的剩余次数。
        handleProjectSelectChange(selectedList) {
          const selectedProjectCodes = selectedList
              .filter(item => item)
              .map(item => item.projectcode)

          const unselectedList = this.list.filter(item =>
              this.selectedProjectCodes.indexOf(item.projectcode) > -1 &&
              selectedProjectCodes.indexOf(item.projectcode) === -1
          )

          unselectedList.forEach(item => {
            if (Number(item.execnumValue || 0) > 0) {
              this.$set(item, 'execnumValue', '0')
              this.handleExecnumChange(item)
            }
          })

          selectedList.forEach(item => {
            if (!item) {
              return
            }

            if (!item.execnumValue || Number(item.execnumValue) <= 0) {
              this.$set(item, 'execnumValue', '1')
              this.handleExecnumChange(item)
            }
          })

          this.selectedProjectCodes = this.result
              .filter(item => item)
              .map(item => item.projectcode)
        },
        assignTreat(){

            if(this.isAssigning){
              return
            }

            if(this.isNoAssignableProject){
              this.goPrescription()
              return
            }

            if(!this.uroomid){
              Toast('请先安排床位')
              return
            }

            if(this.result.length == 0){
                Toast('请选择分诊项目！')
                return
            }

            console.log("---",this.userprojectlist)

            // 消费患者
            let repeatlist = this.userprojectlist.filter(
                item => Number(item.curexecnum) > 0 && Number(item.execstatus) > 1
            )

            console.log("repeatlist",repeatlist)

            // 选中项目
            let result = []

            this.result.forEach(item => {
              const repeatItem = repeatlist.find(
                  r => r.projectcode === item.projectcode
              )

              if (repeatItem && Number(repeatItem.execstatus) > 1) {
                result.push(item)
              }
            })

            console.log("result",result)


            let msg = '';
            if(repeatlist.length > 0){
                if(result.length == 0){
                    msg =  `该患者当天有执行其他项目：${(repeatlist.map(item =>  item.projectname)).join('、')}，您确认是否再次分诊？`
                }else if(result.length){
                    msg = `该患者当天有执行项目：${(result.map(item =>  item.projectname)).join('、')}，您确认是否再次分诊？`
                }
            }else{
               if(+this.historynum > 0){
                msg = `该患者有历史未完成的项目，您确认是否再次分诊?`
               }else{
                msg = `您确认是否提交此分诊数据？`
               }
            }

            Dialog.confirm({
                title: '提示',
                message: msg,
                confirmButtonColor:'#CF8C57',
            })
            .then(() => {
                // on confirm
                this.isAssigning = true
                this.treatJudge()
            })
            .catch(() => {
                // on cancel
            });



        },
        treatJudge(){
            let selectoption = '0';
            if(this.userid == this.useuserid) {
                if(this.customerid == this.usecustomerid) {
                    this.getTreat(selectoption)
                } else {
                    if(this.usecustomerid == 0) {
                        selectoption = '1'
                        this.getTreat(selectoption)
                    } else {
                        selectoption = '2'
                        this.getTreat(selectoption)
                    }
                }
            } else {
                this.sms = ''
                // 取消验证码
                // this.shownum = true
                selectoption = '3'
                this.getTreat(selectoption)
            }
        },
        /**
         * 获取分诊成功后返回理疗工作台的目标 tab，追加项目返回执行中，普通分诊返回待执行。
         */
        getAssignSuccessReturnTab() {
            return this.treatstatus == '1' ? '3' : '2'
        },
        /**
         * 分诊成功后保存理疗工作台目标 tab。
         */
        saveAssignSuccessReturnTab() {
            sessionStorage.setItem('TREAT_PAGE_TAB', this.getAssignSuccessReturnTab())
        },
        /**
         * 标记返回待执行后需要加载完整列表并默认展开最后一项。
         */
        saveWaitLoadToEndFlag() {
            sessionStorage.setItem('TREAT_WAIT_LOAD_TO_END', '1')
        },
        /**
         * 标记点击返回待执行后，待执行列表加载完成需要滚动到底部。
         */
        saveWaitScrollToBottomFlag() {
            sessionStorage.setItem(TREAT_WAIT_SCROLL_TO_BOTTOM, '1')
        },
        /**
         * 保存返回理疗工作台所需状态，待执行入口保留加载到底部并展开最后一项的逻辑。
         */
        saveTreatReturnState() {
            this.saveAssignSuccessReturnTab()
            if (this.getAssignSuccessReturnTab() == '2') {
                this.saveWaitLoadToEndFlag()
                this.saveWaitScrollToBottomFlag()
            } else {
                sessionStorage.removeItem('TREAT_WAIT_LOAD_TO_END')
                sessionStorage.removeItem(TREAT_WAIT_SCROLL_TO_BOTTOM)
            }
        },
        /**
         * 分诊页进入签名后，签名保存成功返回分诊成功对应的理疗工作台 tab。
         */
        saveSignatureSuccessReturnTab() {
            sessionStorage.setItem('SIGNATURE_SUCCESS_RETURN_TAB', this.getAssignSuccessReturnTab())
        },
        /**
         * 标记签名保存成功后明确返回理疗工作台，避免从免预约分诊入口返回到原页面。
         */
        saveSignatureSuccessReturnPath() {
            sessionStorage.setItem('SIGNATURE_SUCCESS_RETURN_PATH', '/treatPage')
        },
        /**
         * 获取分诊成功后签名使用的服务ID，优先使用接口返回值，其次使用本次选中项目的 serviceids。
         */
        getAssignSuccessServiceid(response) {
            const body = response && response.response_body ? response.response_body : {}
            const serviceid = body.serviceid || body.serviceId || body.allserviceid || body.serviceids
            if (serviceid) {
                return (serviceid + '').split(',').filter(id => id)[0] || ''
            }

            const bodyListServiceid = this.getFirstServiceidFromList(body.list)
                || this.getFirstServiceidFromList(body.projectlist)
            if (bodyListServiceid) {
                return bodyListServiceid
            }

            const project = this.result.find(item => item && item.serviceids)
            if (!project) {
                return ''
            }

            return (project.serviceids + '').split(',').filter(id => id)[0] || ''
        },
        /**
         * 从接口返回列表中提取第一条服务ID，兼容项目列表或患者聚合列表。
         */
        getFirstServiceidFromList(list) {
            if (!Array.isArray(list)) {
                return ''
            }

            const serviceItem = list.find(item => {
                return item && (item.serviceid || item.serviceId || item.allserviceid || item.serviceids)
            })
            if (serviceItem) {
                const serviceid = serviceItem.serviceid || serviceItem.serviceId || serviceItem.allserviceid || serviceItem.serviceids
                return (serviceid + '').split(',').filter(id => id)[0] || ''
            }

            const patientItem = list.find(item => item && Array.isArray(item.projectlist))
            return patientItem ? this.getFirstServiceidFromList(patientItem.projectlist) : ''
        },
        /**
         * 判断分诊接口是否表示当前患者已全部签名。
         */
        isAssignAllSigned(response) {
            const body = response && response.response_body ? response.response_body : {}
            return body.isAllSign === true || body.isAllSign === 'true'
        },
        /**
         * 分诊成功后处理跳转，追加项目和普通分诊已全部签名时返回理疗工作台。
         */
        handleAssignSuccess(response) {
            if (this.treatstatus == '1') {
                this.returnTreatPage()
                return
            }

            if (this.isAssignAllSigned(response)) {
                this.returnTreatPage()
                return
            }

            this.assignSuccessServiceid = this.getAssignSuccessServiceid(response)
            this.saveAssignSuccessReturnTab()
            this.$store.dispatch('changeIsRefresh', '1')
            this.goAssignSignature()
        },
        /**
         * 分诊成功后返回理疗工作台目标 tab。
         */
        returnTreatPage() {
            this.saveTreatReturnState()
            this.$store.dispatch('changeIsRefresh', '1')
            this.$router.push('/treatPage')
        },
        /**
         * 分诊成功后跳转签名页，默认签署患者当天全部未签名项目。
         */
        goAssignSignature() {
            if (!this.assignSuccessServiceid) {
                Toast.fail('暂无可签名项目')
                return
            }

            this.saveTreatReturnState()
            this.saveSignatureSuccessReturnTab()
            this.saveSignatureSuccessReturnPath()
            this.$router.replace({
                path:'/signature',
                query:{
                    serviceid:this.assignSuccessServiceid,
                    isAll:'true',
                }
            })
        },
        getTreat(selectoption,captchano){

            var res = new Promise((resolve,reject)=>{

                // 接口请求期间锁定确认按钮，接口返回成功或失败后再释放。
                this.isAssigning = true


                let project = []
                this.result.forEach(item => {
                  project.push({
                    projectname: item.projectname,
                    projectcode: item.projectcode,
                    doctors: item.doctors,
                    allpoints: item.allpoints,
                    num: Number(item.execnumValue) > 0 ? item.execnumValue : '1',
                    serviceids:item.serviceids
                  })
                })

                let data = {
                    username:this.username,
                    projectlist:project,
                    selectoption,
                    userid:this.userid,
                    customerid:this.customerid,
                    useuserid:this.useuserid,
                    usecustomerid:this.usecustomerid,
                    captchano,
                    execclinicid:sessionStorage.ClinicId,
                    appointmentid:this.appointmentid,
                    roomid:this.uroomid,
                    oprtype:this.oprtype,
                    qrydate:this.qryDate,
                    treatstatus:this.treatstatus
                }

                console.log("req",data)

                wxtreattriageopr(data).then(response =>{
                    resolve(response)
                    this.isAssigning = false
                    this.handleAssignSuccess(response)

                })
                .catch((err) => {
                    // on cancel
                    resolve(err)
                    this.isAssigning = false
                    Toast.fail(err.response_head.retinfo.retmsg)
                });
            })
        return res
        },
       chooseDoctor(item, index){
           if (!this.doctorList || this.doctorList.length === 0) {
             Toast('暂无空闲医生')
             return
           }
            this.selectDoctor = item.doctor || this.username
            this.showPicker = true
            this.treatitem = {
                item,   // 直接用引用（关键）
                index
            }
        },
        chooseRoom(item){

            this.showPicker2 = true
            this.treatitem = item
        },
        addDoctor(item){
            const newDoctor = {
                dispname: '请选择医生',
                username: '',
                ismain: 0
            }
            this.$set(item, 'doctors', [...item.doctors, newDoctor])
        },
        onConfirmDoctor(val){

            const item = this.treatitem.item

            if (!item) return

            if (!Array.isArray(item.doctors)) {
                this.$set(item, 'doctors', [])
            }

            const newDoctors = item.doctors.map((d, i) => {
                if (i === this.treatitem.index) {
                    return {
                        ...d,
                        dispname: val.dispname,
                        username: val.username
                    }
                }
                return d
            })

            // 关键：直接替换引用
            this.$set(item, 'doctors', newDoctors)
            console.log("this.list",this.list)

            this.selectDoctor = null
            this.showPicker = false
        },
        onConfirmRoom(val){
            this.treatitem.room = val.roomname
            this.treatitem.roomid = val.roomid
            this.showPicker2 = false
        },
        openAcupointDialog(item) {
            this.currentItemRef = item
            this.currentAcupointData = item.doctors
            this.currentUserId = this.useuserid
            this.currentCustomerId = this.usecustomerid
            this.currenttCode = item.projectcode
            this.showAcupointDialog = true
        },
        handleAcupointSave(newList,allPoints) {
          if (!this.currentItemRef) return

          // 关键：直接覆盖 doctors
          this.$set(this.currentItemRef, 'doctors', newList)
          this.$set(this.currentItemRef, 'allpoints', allPoints)
        },
        openBedPopup() {
          if (this.isNoAssignableProject) {
            return
          }

          this.selectedBed = null
          this.bedList = []
          this.showBedPopup = true
          wxqryfreeroom({ clinicid: this.clinicid }).then(response => {
            if (response.response_body && response.response_body.list) {
              this.bedList = response.response_body.list
              // 增加“无需床位”选项
              this.bedList.push({
                room_id: -1,
                room_name: '无需床位',
                use_count: 0
              })

              let defaultBed = null
              if (this.uroomid) {
                defaultBed = this.bedList.find(
                    bed => bed.room_id == this.uroomid
                )
              }

              // 如果没有当前床位，则默认选中第一个空闲床位
              if (!defaultBed) {
                defaultBed = this.bedList.find(
                    bed => bed.use_count <= 0
                )
              }

              // 设置默认选中
              if (defaultBed) {
                this.selectedBed = defaultBed
              }
            }
          })
        },
        selectBed(bed) {
          this.selectedBed = bed
        },

        /**
         * 判断床位是否为当前患者本人正在使用。
         */
        isCurrentPatientBed(bed) {
          if (!bed || bed.room_id == -1) {
            return false
          }

          return bed.use_count > 0
              && bed.user_id == this.userid
              && bed.customer_id == this.customerid
        },

        /**
         * 判断床位是否已被其他患者占用。
         */
        isOtherPatientBed(bed) {
          if (!bed || bed.room_id == -1) {
            return false
          }

          return bed.use_count > 0
              && (bed.user_id != this.userid || bed.customer_id != this.customerid)
        },

        /**
         * 已占用床位确认安排前提示是否强制完成并安排。
         */
        showForceAssignBedDialog() {
          Dialog.confirm({
            title: '提示',
            message: '该床位的患者项目还没结束，是否强制完成并安排床位',
            confirmButtonText: '确认安排',
            cancelButtonText: '返回',
            confirmButtonColor: '#CF8C57'
          }).then(() => {
            this.confirmForceAssignBed()
          }).catch(() => {
            // 点击返回，不做任何事
          })
        },

        /**
         * 强制完成占用床位患者的项目后，继续执行选择床位。
         */
        confirmForceAssignBed() {
          wxoprtreat({
            oprType: 3,
            doctor: this.username,
            useUserId: this.selectedBed.user_id,
            useCustomerId: this.selectedBed.customer_id
          }).then((response) => {
            if (response.response_body.flag) {
              this.saveAssignBed()
            } else {
              Toast.fail(response.response_body.msg)
            }
          })
        },
        getBedStatusText(bed) {
          // 无需床位
          if (bed.room_id == -1) {
            return ''
          }
          if (bed.use_count > 0) {
            if (this.userid ==  bed.user_id &&
                this.customerid == bed.customer_id) {
              return '本人';
            }
            return '有人';
          }
          return '空闲';
        },
        confirmAssignBed() {
          if (!this.selectedBed) {
            Toast('请先选择床位')
            return
          }
          if (this.isCurrentPatientBed(this.selectedBed)) {
            this.saveAssignBed()
            return
          }

          if (this.isOtherPatientBed(this.selectedBed)) {
            if (this.selectedBed.is_all_executing == 0) {
              Toast.fail('该床位存在未开始执行的项目，请选择其他床位')
              return
            }

            this.showForceAssignBedDialog()
            return
          }
          this.saveAssignBed()
        },

        /**
         * 保存当前选择的正常床位到分诊参数。
         */
        saveAssignBed() {
          this.uroomid = this.selectedBed.room_id
          this.uroomname = this.selectedBed.room_name
          this.showBedPopup = false
        },
        getCurDate() {
          const nowDate = new Date();
          this.formatDate(nowDate)
        },
        // 初始化接口查询日期，优先使用理疗工作台传入的日期，无传入时回退到当天。
        initQryDate() {
          if (this.qryDate) {
            this.date = this.qryDate
            this.defaultDate = new Date(this.qryDate);
            return
          }

          this.getCurDate()
          this.qryDate = this.date
        },
        formatDate(d) {
          const curDate = {
            year: d.getFullYear(),
            month: d.getMonth() + 1,
            date: d.getDate(),
          }
          const newmonth = curDate.month>=10?curDate.month:'0'+curDate.month
          const day = curDate.date>=10?curDate.date:'0'+curDate.date
          this.date = curDate.year + '-' + newmonth + '-' + day
          this.defaultDate = new Date(this.date);
        },

        handleExecnumChange(item) {
          const oldExecNum = Number(item._lastExecnumValue ?? item.curexecnum ?? 0)
          let newExecNum = Number(item.execnumValue || 0)

          const diff = newExecNum - oldExecNum
          const newRemainNum = Number(item.remainnum || 0) - diff

          if (newRemainNum > Number(item.totalnum || 0)) {
            Toast(`剩余次数不能大于总次数${item.totalnum}次`)
            this.$set(item, 'execnumValue', String(oldExecNum))
            return
          }

          if (newRemainNum < 0) {
            Toast('执行次数不能大于剩余次数')
            this.$set(item, 'execnumValue', String(oldExecNum))
            return
          }

          this.$set(item, 'remainnum', newRemainNum)
          this.$set(item, '_lastExecnumValue', newExecNum)

          const index = this.result.findIndex(
              val => val.projectcode === item.projectcode
          )

          if (newExecNum === 0) {
            if (index > -1) {
              this.result.splice(index, 1)
            }
          } else {
            if (index === -1) {
              this.result.push(item)
            }
          }
        }
    }
}
</script>
<style lang="scss" scoped>
.my_treat_page{
    margin-bottom: 0;
    min-height: 100vh;
    background-color: #F6F6F4;
    .head{
        background-color: #CF8C57;
        border-radius: 10px;
        color: #fff;
        font-size: 12px;
        padding: 15px;
        display: flex;
        align-items: center;
        font-size: 12px;
        .text{
            margin-bottom: 10px;
            span{
                margin-right: 8px;
            }
        }
    }
    .list{
        background-color: #fff;
        border-radius: 10px;
        margin-top: -15px;
        padding: 15px 12px;
        margin-bottom: 80px;
        .list_top{

            display: flex;

                flex-wrap: wrap;
            .user{
                width: 95px;
                height: 45px;
                padding: 5px;
                text-align: center;
                background-color: #F5F5F5;
                border-radius: 8px;
                margin-right: 8px;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-wrap: wrap;
                margin-bottom: 8px;

                .item{
                    width: 80px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }

            }
            .active{
                background: rgba(207,140,87,0.2);
                border-radius: 8px;
                border: 1px solid #CF8C57;
            }
        }
        .list_btn{
            width: 140px;
            height: 35px;
            line-height: 35px;
            border-radius: 5px;
            background-color: #CF8C57;
            font-size: 16px;
            color: #fff;
            text-align: center;
            margin-bottom: 10px;
        }
        .list_btn_disabled{
            background-color: #CCCCCC;
            color: #FFFFFF;
            pointer-events: none;
        }
        .list_item{
            background-color: #F5F5F5;
            border-radius: 10px;
            padding: 10px;
            margin-bottom: 10px;

            .tream{
                display: flex;
                justify-content: space-between;
                align-items: center;
                .text{
                    font-weight: 600;
                    font-size: 16px;
                    color: #323333;
                    line-height: 22px;
                    text-align: left;
                }
            }
            .action-buttons{
                display: flex;
                justify-content: flex-end;
                align-items: center;
                gap: 10px;
                margin-top: 10px;
                .execute-times{
                    display: flex;
                    align-items: center;
                    font-size: 14px;
                    color: #323333;
                    .execute-label{
                        white-space: nowrap;
                    }
                    .execute-input{
                        width: 58px;
                        height: 32px;
                        padding: 0 !important;
                        background-color: #fff;
                        border-radius: 4px;
                    }
                    .execute-input /deep/ .van-cell {
                      padding: 0 !important;
                    }
                }
                .r-btn{
                    border-radius : 5px
                }
                .l-btn{
                    color:#323333;
                    background:none;
                    border:none;
                    padding:5px;
                }
            }
            .main-tag{
                background-color: #CF8C57;
                color: #fff;
                font-size: 11px;
                width: 18px;
                height: 18px;
                line-height: 18px;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                border-radius: 50%;
                margin-right: 6px;
                flex-shrink: 0;
            }
            .doctor-title{
                display: inline-flex;
                align-items: center;
                line-height: 18px;
            }
        }
    }
    .van-cell{
        padding:5px 5px;
        background-color: #F5F5F5;
        margin-bottom:5px;

        ::v-deep .van-icon {
            display: flex;
            align-items: center;
        }
    }


}
::v-deep .van-checkbox__label{
    width: 100% !important;
}
.my_treat_page .van-cell {
    ::v-deep .van-field{

        background-color: #fff;
    }
}
.van-dialog{

    ::v-deep .van-dialog__header{
        padding: 10px 0  25px !important;
    }
    ::v-deep .van-field{
        background-color: #fff;
        margin-bottom: 5px;
    }
}

.bed-dialog :deep(.van-dialog__content) {
  max-height: 70vh;
  overflow-y: auto;
}
.bed-dialog :deep(.van-dialog__header) {
  padding: 20px 20px 10px !important;
}
.dialog-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.dialog-title span:first-child {
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.bed-popup {
  padding: 10px 0 0;
}
.patient-info-section {
  background: #CF8C57;
  border-radius: 5px;
  padding: 8px 10px;
  margin: 0 20px 24px;
}
.patient-header {
  font-size: 20px;
  color: #fff;
}
.patient-detail {
  font-size: 16px;
  color: #fff;
}
.bed-section {
  padding: 0 20px;
}
.section-title {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin-bottom: 16px;
}
.bed-list {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}
.bed-item {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  font-size: 16px;
  cursor: pointer;
  padding: 5px;
  flex-direction: column;
}
.bed-occupied {
  background: #ddd;
  color: #999;
  cursor: pointer;
}
.bed-available {
  background: #fff;
  border: 1px solid #CF8C57;
  color: #CF8C57;
}
.bed-selected {
  background: #CF8C57 !important;
  color: #fff !important;
  border: 1px solid #CF8C57;
}
.confirm-section {
  padding: 20px;
}
.confirm-btn {
  width: 100%;
  height: 50px;
  background: #CF8C57;
  color: #fff;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: 600;
}

.freeRoom{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.freeRoom img{
  width: 30px;
}
</style>
